import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import config from "./config";
import "./Invite.css";

const Invite = ({refreshUserAccountInfo, refreshTeam}) => {
  const [invitations, setInvitations] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function

  const API_URL = config.API_URL;

  useEffect(() => {
    fetchInvitations().catch(() => setError("Invitations could not be loaded. Please refresh and try again."));
  }, []);

  const fetchInvitations = async () => {
    const userEmail = localStorage.getItem("loggedInEmail");
    const response = await fetch(`${API_URL}api/User/GetInvitations/${encodeURIComponent(userEmail)}`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
    if (response.ok) {
      const data = await response.json();
      setInvitations(data);
    } else throw new Error("Invitations could not be loaded.");
  };

  const handleResponse = async (invitationId, accept) => {
    if (busy) return;
    setBusy(true); setError("");
    try {
    // Prepare form data
    const formData = new FormData();
    formData.append("invitationId", invitationId);
    formData.append("accept", accept);

    // Send response to the server
    const response = await fetch(`${API_URL}api/User/RespondToInvitation`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.ok) {
      // Navigate to the dashboard page after handling the invitation
      refreshUserAccountInfo();
      refreshTeam();
      navigate("/dashboard");
    } else {
      const result = await response.json().catch(() => ({}));
      setError(result.message || "The invitation could not be answered.");
    }
    } catch { setError("The invitation response could not be confirmed. Please retry."); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div className="invite">
        {error && <p role="alert">{error}</p>}
        {invitations.length > 0 ? (
          invitations.map((invitation) => (
            <div key={invitation.InvitationId} className="invite-buttons-container">
              <p className="invite-message">
                You have been invited to join {invitation.InvitedTeamName} by {invitation.InvitingUserFirstName} {invitation.InvitingUserLastName}
              </p>
              <div className="buttons-row">
                <button disabled={busy} className="invite-accept-button" onClick={() => handleResponse(invitation.InvitationId, true)}>
                  Accept
                </button>
                <button disabled={busy} className="invite-decline-button" onClick={() => handleResponse(invitation.InvitationId, false)}>
                  Decline
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>You have no current team invites.</p>
        )}
      </div>
    </div>
  );
};

export default Invite;
